



















import { computed, defineComponent, ref, toRefs } from '@vue/composition-api';
import { getAccountToday, dayjs } from '@tt4b/ttam-utils';

const name = 'ttam-schedule-starttime-datepicker';

export default defineComponent({
  name,
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    timezone: {
      type: String,
      default: 'Asia/Shanghai',
    },
    timezoneOffset: {
      type: Number,
      default: 0,
    },
    bottomShortcutsOptions: {
      type: Object,
      default: () => ({}),
    },
    disableScrollControl: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { timezone } = toRefs(props);
    const startDisabledDateMap = ref({});

    const startDisabledDateSetter = cur => {
      if (startDisabledDateMap.value[cur] && new Date().getTime() <= startDisabledDateMap.value[cur].__expirationTime) {
        return startDisabledDateMap.value[cur].result;
      }
      if (!timezone.value) {
        return;
      }
      const curDate = (dayjs(cur) as any).tz(timezone.value);
      const result = curDate.isBefore(getAccountToday(timezone.value));
      // 缓存结果 & 设置缓存时间
      startDisabledDateMap.value[cur] = {
        __expirationTime: new Date().getTime() + 3 * 60 * 1000,
        result,
      };

      return result;
    };
    return {
      name,
      startDisabledDateSetter,
      _startTime: computed({
        get: () => props.value,
        set: v => {
          emit('change', v);
          emit('input', v);
        },
      }),
    };
  },
});
